import React from 'react';

// icon
import CopyIcon from '@nykaa/ui-components/Icons/copy';

// styles
import { CopyCodeWrapper } from './styles';

const COPY_ICON_SIZE = '12px';

export default function CopyCode({
  copyCode,
  handleCopyClick,
}: {
  copyCode: string;
  handleCopyClick: (e: React.MouseEvent) => void;
}) {
  const onCopyCodeClick = (e: React.MouseEvent<HTMLDivElement>) => {
    handleCopyClick(e);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return (
    <CopyCodeWrapper>
      <div
        className="copycode-container"
        onClick={onCopyCodeClick}
        onKeyDown={onKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Copy code"
      >
        {copyCode}
        <CopyIcon size={COPY_ICON_SIZE} />
      </div>
    </CopyCodeWrapper>
  );
}
